import React from 'react';

const Eye = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.5 6C1.5 6 4.85786 2.25 9 2.25C13.1421 2.25 16.5 6 16.5 6",
      stroke: "#BFBFBF",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.158 9.78374C16.386 10.1035 16.5 10.2633 16.5 10.5C16.5 10.7367 16.386 10.8965 16.158 11.2163C15.1334 12.6529 12.5169 15.75 9 15.75C5.48308 15.75 2.86657 12.6529 1.84203 11.2163C1.61401 10.8965 1.5 10.7367 1.5 10.5C1.5 10.2633 1.61401 10.1035 1.84203 9.78374C2.86657 8.34708 5.48308 5.25 9 5.25C12.5169 5.25 15.1334 8.34708 16.158 9.78374Z",
      stroke: "#BFBFBF",
      strokeWidth: "1.5"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.25 10.5C11.25 9.25736 10.2426 8.25 9 8.25C7.75736 8.25 6.75 9.25736 6.75 10.5C6.75 11.7426 7.75736 12.75 9 12.75C10.2426 12.75 11.25 11.7426 11.25 10.5Z",
      stroke: "#BFBFBF",
      strokeWidth: "1.5"
    }
  )
);
Eye.displayName = "Icons.Eye";

export { Eye };
//# sourceMappingURL=Eye.js.map
